import { UserPermission } from '@/modules/permission/enum';
export const checklistRoutes = [
    {
        path: '',
        name: 'Checklist',
        exact: true,
        component: () => import('../views/ChecklistIndex.vue'),
        meta: {
            breadcrumb: [{ parent: 'Checklist', label: 'Manage Checklist' }],
            permissions: [UserPermission.READ_CALLSIGN],
        },
    },
];
